import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ExperienceListContext } from '#providers/experiences/experience-list/ExperienceList.context.ts';
import type { TExperienceListContextValue } from '#providers/experiences/experience-list/ExperienceList.types.ts';

export const useExperienceList = (): TExperienceListContextValue =>
  useRequiredContext(
    ExperienceListContext,
    'useExperienceList is only available inside an ExperienceListProvider',
  );
